import { css } from '@emotion/css';
import { computed } from 'vue';
import { useTheme } from '../../../composables/theme';

export const useStyles = () => {
  const theme = useTheme();

  const baseClass = computed(() => css({
    paddingBottom: '0.625rem',
    color: theme.value.colors.gray.main,
    alignItems: 'center',
    whiteSpace: 'nowrap',
    cursor: 'pointer',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    maxWidth: '14rem',
    textWrap: 'nowrap',
    WebkitLineClamp: 1,
    WebkitBoxOrient: 'vertical',
    '&--selected': {
      fontWeight: theme.value.typography.fontWeight.semibold,
      borderBottom: `0.125rem solid ${theme.value.colors.primary.dark}`,
      marginBottom: '-0.125rem',
    },
    '&__dropdown-trigger': {
      fontWeight: theme.value.typography.fontWeight.semibold,
      color: theme.value.colors.primary.dark,
    },
  }));

  return baseClass;
};
